import $ from '../$';
import map from '../functions/map';
import { JQ } from '../JQ';
$.fn.map = function (callback) {
    return new JQ(map(this, (element, i) => callback.call(element, i, element)));
};
